export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#260600',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#FF4A19',
  },
  {
    path: 'M348.16 329.216h68.096l140.8 365.568h-68.608l-34.304-96.768h-145.92L273.92 694.784h-66.048z m-22.528 220.16h111.616l-54.784-157.184h-1.536zM583.68 430.08h55.296v38.912l1.024 1.024c17.408-29.184 47.616-47.104 82.432-47.104 57.344 0 93.696 30.72 93.696 90.112v181.76H757.76v-166.4c-1.024-41.472-17.408-59.392-51.712-59.392-38.912 0-64 30.72-64 69.632v156.16H583.68z',
    fill: '#FF4A19',
  },
]
